// Override Settings
if (typeof boostPFSThemeConfig !== "undefined") {
  var boostPFSFilterConfig = {
    general: {
      limit: 20, // boostPFSConfig.custom.products_per_page, // limit 20 to use ajax to fix price
      /* Optional */
      loadProductFirst: false,
      refineByStyle: "style2",
      filterTreeMobileIcon:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-filter" viewBox="0 0 64 64"><path d="M48 42h10M48 42a5 5 0 1 1-5-5 5 5 0 0 1 5 5zM7 42h31M16 22H6M16 22a5 5 0 1 1 5 5 5 5 0 0 1-5-5zM57 22H26"></path></svg>',
    },
    selector: {
      avoidStickyHeader:
        ".site-header, .site-header--opening, #shopify-section-header",
    },
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    const { tags } = data;

    let isParent = false;
    let isNewTag = false,
      comingSoonTag = false,
      autumnEditTag = false,
      specialOfferTag = false,
      saleTag = false,
      clearanceTag = false,
      bestsellerTag = false,
      limitedEditionTag = false,
      isCharityProduct = false,
      isFeelGoodProduct = false,
      isSaveTenProduct = false,
      isSaveFifteenProduct = false,
      isSaveTwentyProduct = false,
      isSaveTwentyfiveProduct = false,
      isSaveThirtyProduct = false,
      isSaveThirtyfiveProduct = false,
      isSaveFortyProduct = false,
      isSaveFiftyProduct = false,
      isSaveSixtyProduct = false,
      newInSaleTag = false,
      furtherReductionTag = false;
    tags.forEach((tag) => {
      if (tag === "Parent") {
        isParent = true;
      }

      switch (tag.toLowerCase()) {
        case "roundel:new":
          isNewTag = true;
          break;
        case "roundel:comingsoon":
          comingSoonTag = true;
          break;
        case "roundel:autumnedit":
          autumnEditTag = true;
          break;
        case "roundel:specialoffer":
          specialOfferTag = true;
          break;
        case "roundel:sale":
          saleTag = true;
          break;
        case "roundel:clearance":
          clearanceTag = true;
          break;
        case "roundel:charity":
          isCharityProduct = true;
          break;
        case "roundel:feelgood":
          isFeelGoodProduct = true;
          break;
        case "roundel:save10":
          isSaveTenProduct = true;
          break;
        case "roundel:save15":
          isSaveFifteenProduct = true;
          break;
        case "roundel:save20":
          isSaveTwentyProduct = true;
          break;
        case "roundel:save25":
          isSaveTwentyfiveProduct = true;
          break;
        case "roundel:save30":
          isSaveThirtyProduct = true;
          break;
        case "roundel:save35":
          isSaveThirtyfiveProduct = true;
          break;
        case "roundel:save40":
          isSaveFortyProduct = true;
          break;
        case "roundel:save50":
          isSaveFiftyProduct = true;
          break;
        case "roundel:save60":
          isSaveSixtyProduct = true;
          break;
        case "roundel:limitededition":
          limitedEditionTag = true;
          break;
        case "roundel:bestseller":
          bestsellerTag = true;
          break;
        case "roundel:new-in-sale":
          newInSaleTag = true;
          break;
        case "roundel:further-reduction":
          furtherReductionTag = true;
          break;

        default:
        // code block
      }
      if (tag.startsWith("_discount")) {
        hasDiscountTag = true;
      }
    });
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(
      /{{grid_item_width}}/g,
      boostPFSConfig.custom.grid_item_width
    );
    itemHtml = itemHtml.replace(
      /{{products_per_row}}/g,
      boostPFSConfig.custom.products_per_row
    );

    // Add Thumbnail
    // var aspectRatio = images.length > 0 ? 0.75 : "";
    /* Boost-fix */
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : "";
    /* Boost-fix */
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : "100";
    var thumb =
      images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = "";
    if (
      boostPFSConfig.custom.hasOwnProperty("product_grid_image_fill") &&
      boostPFSConfig.custom.product_grid_image_fill
    ) {
      productGridImageFillClass = "grid__image-fill";
    }
    var itemImagesHtml = "";
    if (boostPFSConfig.custom.product_grid_image_size == "natural") {
      itemImagesHtml +=
        '<div class="image-wrap" style="height: 0; padding-bottom: ' +
        paddingBottom +
        '%;" id="swiperContainer">';
      itemImagesHtml +=
        "<img " +
        'class="grid-product__image lazyload" ' +
        'data-src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
        'data-aspectratio="' +
        aspectRatio +
        '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml +=
        "<noscript>" +
        '<img class="grid-product__image" ' +
        'src="' +
        Utils.getFeaturedImage(images, "{width}x") +
        '" ' +
        'alt="{{itemTitle}">' +
        "</noscript>";
      itemImagesHtml += "</div>";
    } else {
      itemImagesHtml += '<div class="swiper product_card_swiper">';
      itemImagesHtml += '<div class="swiper-wrapper">';
      function buildSrcSet(imageUrl, widths = [240, 360, 480, 750]) {
        return widths
          .map(
            (width) =>
              `${imageUrl.replace(/(\.jpg|\.jpeg|\.png)(\?.*)?$/, `_${width}x$1`)} ${width}w`
          )
          .join(', ');
      }

      for (let i = 0; i < images.length; i++) {
        const srcSet = buildSrcSet(images[i].src);
        const fallbackSrc = images[i].src.replace(/(\.jpg|\.jpeg|\.png)(\?.*)?$/, '_240x$1');
        const lazySrc = images[i].src.replace(/(\.jpg|\.jpeg|\.png)(\?.*)?$/, '_480x$1');

        itemImagesHtml += `
          <div class="swiper-slide">
            <div class="grid__image-ratio grid__image-ratio--${boostPFSConfig.custom.product_grid_image_size}">
              <img
                class="lazyload ${productGridImageFillClass}"
                src="${fallbackSrc}"
                data-src="${lazySrc}"
                data-srcset="${srcSet}"
                data-sizes="(max-width: 767px) 50vw, 25vw"
                data-aspectratio="${aspectRatio}"
                alt="{{itemTitle}}"
              >
            </div>
          </div>
        `;

      }
      itemImagesHtml += "</div>";
      itemImagesHtml +=
        "<div data-carousel-pagination class='swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal'></div>";
      itemImagesHtml += "</div>";
    }

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = "";

    if (onSale) {
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.regular_price +
        "</span>";
      itemPriceHtml +=
        '<span class="grid-product__price--original">' +
        Utils.formatMoney(data.compare_at_price_min) +
        "</span>";
      itemPriceHtml +=
        '<span class="visually-hidden">' +
        boostPFSConfig.label.sale_price +
        "</span>";
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(
        /{{ price }}/g,
        Utils.formatMoney(data.price_min)
      );
    } else {
      // from goes here
      if (isParent && !onSale) itemPriceHtml += "<span>from </span>";
      itemPriceHtml += "<span>" + Utils.formatMoney(data.price_min) + "</span>";
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = "";
      if (boostPFSConfig.custom.product_save_type == "dollar") {
        savePrice = Utils.formatMoney(
          data.compare_at_price_min - data.price_min
        );
      } else {
        savePrice = Math.round(
          ((data.compare_at_price_min - data.price_min) * 100) /
            data.compare_at_price_min
        );
        savePrice += "%";
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(
        /{{ saved_amount }}/g,
        savePrice
      );
      itemPriceHtml +=
        '<span class="grid-product__price--savings">' +
        savePriceText +
        "</span>";
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? "grid-product__link--disabled" : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    let hasDiscountTag = false;
    let discountCodeLabel;
    const isInDiscountCollection = data.collections.find((coll) => {
      if (coll.handle.includes("discount")) {
        return coll.title;
      }
    });
    if (isInDiscountCollection != undefined) {
      discountCodeLabel = isInDiscountCollection.title;
    }

    var itemLabelHtml = "";

    if (bestsellerTag) {
      itemLabelHtml += `
      <div class="grid-product__tag message-tag">
        <span>
          ${boostPFSConfig.custom.bestseller_product_tag}
        </span>
      </div>`;
    }
    if (limitedEditionTag) {
      itemLabelHtml += `
      <div class="grid-product__tag message-tag">
        <span>
          ${boostPFSConfig.custom.limited_edition_product_tag}
        </span>
      </div>`;
    }
    if (isNewTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.new_bg_color}">
        <span style="color: ${boostPFSConfig.custom.new_text_color}">
          ${boostPFSConfig.custom.new_product_tag}
        </span>
      </div>`;
    }
    if (comingSoonTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.coming_soon_bg_color}">
        <span style="color: ${boostPFSConfig.custom.coming_soon_text_color}">
          ${boostPFSConfig.custom.coming_soon_tag}
        </span>
      </div>`;
    }
    if (autumnEditTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.autumn_edit_bg_color}">
        <span style="color: ${boostPFSConfig.custom.autumn_edit_text_color}">
          ${boostPFSConfig.custom.autumn_edit_tag}
        </span>
      </div>`;
    }
    if (specialOfferTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.special_bg_color}">
        <span style="color: ${boostPFSConfig.custom.clearance_text_color}">
          ${boostPFSConfig.custom.special_product_tag}
        </span>
      </div>`;
    }
    if (saleTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.sale_bg_color}">
        <span style="color: ${boostPFSConfig.custom.sale_text_color}">
          ${boostPFSConfig.custom.sale_product_tag}
        </span>
      </div>`;
    }
    if (clearanceTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.clearance_bg_color}">
        <span style="color: ${boostPFSConfig.custom.clearance_text_color}">
          ${boostPFSConfig.custom.clearance_product_tag}
        </span>
      </div>`;
    }

    // NEW
    if (isCharityProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.charity_bg_color}">
        <span style="color: ${boostPFSConfig.custom.charity_text_color}">
          ${boostPFSConfig.custom.charity_product_tag}
        </span>
      </div>`;
    }
    if (isFeelGoodProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.feel_good_bg_color}">
        <span style="color: ${boostPFSConfig.custom.feel_good_text_color}">
          ${boostPFSConfig.custom.feel_good_product_tag}
        </span>
      </div>`;
    }
    if (isSaveTenProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.ten_bg_color}">
        <span style="color: ${boostPFSConfig.custom.ten_text_color}">
          ${boostPFSConfig.custom.ten_product_tag}
        </span>
      </div>`;
    }
    if (isSaveFifteenProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.fifteen_bg_color}">
        <span style="color: ${boostPFSConfig.custom.fifteen_text_color}">
          ${boostPFSConfig.custom.fifteen_product_tag}
        </span>
      </div>`;
    }
    if (isSaveTwentyProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.twenty_bg_color}">
        <span style="color: ${boostPFSConfig.custom.twenty_text_color}">
          ${boostPFSConfig.custom.twenty_product_tag}
        </span>
      </div>`;
    }
    if (isSaveTwentyfiveProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.twenty_five_bg_color}">
        <span style="color: ${boostPFSConfig.custom.twenty_five_text_color}">
          ${boostPFSConfig.custom.twenty_five_product_tag}
        </span>
      </div>`;
    }
    if (isSaveThirtyProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.thirty_bg_color}">
        <span style="color: ${boostPFSConfig.custom.thirty_text_color}">
          ${boostPFSConfig.custom.thirty_product_tag}
        </span>
      </div>`;
    }
    if (isSaveThirtyfiveProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.thirty_five_bg_color}">
        <span style="color: ${boostPFSConfig.custom.thirty_five_text_color}">
          ${boostPFSConfig.custom.thirty_five_product_tag}
        </span>
      </div>`;
    }
    if (isSaveFortyProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.forty_bg_color}">
        <span style="color: ${boostPFSConfig.custom.forty_text_color}">
          ${boostPFSConfig.custom.forty_product_tag}
        </span>
      </div>`;
    }
    if (isSaveFiftyProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.fifty_bg_color}">
        <span style="color: ${boostPFSConfig.custom.fifty_text_color}">
          ${boostPFSConfig.custom.fifty_product_tag}
        </span>
      </div>`;
    }
    if (isSaveSixtyProduct) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.sixty_bg_color}">
        <span style="color: ${boostPFSConfig.custom.sixty_text_color}">
          ${boostPFSConfig.custom.sixty_product_tag}
        </span>
      </div>`;
    }
    if (newInSaleTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.new_in_sale_bg}">
        <span style="color: ${boostPFSConfig.custom.new_in_sale_text}">
          ${boostPFSConfig.custom.new_in_sale_tag}
        </span>
      </div>`;
    }
    if (furtherReductionTag) {
      itemLabelHtml += `
      <div class="grid-product__tag" style="background: ${boostPFSConfig.custom.further_reduction_bg}">
        <span style="color: ${boostPFSConfig.custom.further_reduction_text}">
          ${boostPFSConfig.custom.further_reduction_tag}
        </span>
      </div>`;
    }

    //
    if (hasDiscountTag && discountCodeLabel != undefined) {
      itemLabelHtml = `<div class="grid-product__tag grid-product__tag--custom"><span>
        ${discountCodeLabel}</span></div>`;
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? '<div class="grid-product__vendor">' + data.vendor + "</div>"
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var itemQuickShopClass = "";
    var itemQuickShopButtonHtml = "";
    // if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
    // Edit - 22/02/2023 - we want the quick view button to show even if 'sold out' - as child items could still be available
    if (boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopClass = "grid-product__has-quick-shop";
      itemQuickShopButtonHtml =
      '<quick-add data-product-title="{{itemHandle}}" data-open-quick-add="{{itemId}}">' +
        '<button class="quick-product__btn quick-product__btn--not-ready small--hide ' +
          (isFirstLoad ? "" : "bc-hide") +
          '">' +
          '<span class="quick-product__label">' +
            boostPFSConfig.label.quick_shop +
          '</span>' +
        '</button>' +
      '</quick-add>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);

    itemHtml = itemHtml.replace(
      /{{itemQuickShopButton}}/g,
      itemQuickShopButtonHtml
    );

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(
      /{{itemSwatchHoverImages}}/g,
      swatchHtml.itemSwatchHoverImages
    );

    var itemQuickShopModal = "";

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal =
        '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
        '<div class="modal__centered">' +
        '<div class="modal__centered-content">' +
        '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
        "</div>" +
        '<button type="button" class="modal__close js-modal-close text-link">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
        '<span class="icon__fallback-text">Close Modal</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrlWithVariant(data)
    );
    itemHtml = itemHtml.replace(/{{itemSKU}}/g, data.skus[0]);

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = "";
    var itemSwatchHoverImagesHtml = "";
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (
          option_name.indexOf("color") != -1 ||
          option_name.indexOf("colour") != -1
        ) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function (variant) {
            var value = variant.merged_options[option_index].split(":")[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(
                boostPFSAppConfig.general.file_url.replace(
                  "/?",
                  "/" + colorValueSlugify + ".png?"
                ),
                "50x"
              );
              var variantImage = Utils.optimizeImage(variant.image, "400x");

              var swatchItem =
                '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                "</a>";

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(
                /{{colorValueSlugify}}/g,
                colorValueSlugify
              );
              swatchItem = swatchItem.replace(
                /{{swatchClass}}/g,
                variant.image ? "color-swatch--with-image" : ""
              );
              swatchItem = swatchItem.replace(
                /{{variantImage}}/g,
                variantImage
              );
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(
                /{{backgroundColor}}/g,
                colorValueSlugify.split("-").pop()
              );

              var swatchHoverImage =
                '<div class="grid-product__color-image grid-product__color-image--' +
                variant.id +
                ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml =
          ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' +
          swatchItems.join("") +
          "</div>";
        itemSwatchHoverImagesHtml = swatchHoverImages.join("");
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml,
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = "";
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml =
        currentPage > 1
          ? boostPFSTemplate.previousActiveHtml
          : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage - 1)
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml =
        currentPage < totalPage
          ? boostPFSTemplate.nextActiveHtml
          : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, currentPage + 1)
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (
        var iBefore = currentPage - 1;
        iBefore > currentPage - 3 && iBefore > 0;
        iBefore--
      ) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift("...");
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push("...");
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = "";
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == "...") {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return "";
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        sortingItemsHtml +=
          '<option value="' + k + '">' + sortingArr[k] + "</option>";
      }
      html = boostPFSTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      // Call theme init function
      theme.sections.reinit();
      theme.initGlobals();
      theme.initQuickShop();
      theme.rteInit();

      jQ(".quick-product__btn").removeClass("bc-hide");
    }

    if (typeof window.Trustpilot !== "undefined") {
      jQ(".trustpilot-widget").each(function () {
        window.Trustpilot.loadFromElement(jQ(this)[0]);
      });
    }

    if (document.querySelectorAll(".grid-product").length) {
      const promoCardPositions = document.querySelectorAll('.promo-card-position');
      const promoCardPages= document.querySelectorAll('.promo-card-page');
      const promoCardImages = document.querySelectorAll('.promo-card-image');
      const promoCardTitles = document.querySelectorAll('.promo-card-title');
      const promoCardDescriptions = document.querySelectorAll('.promo-card-description');
      const promoCardLinks = document.querySelectorAll('.promo-card-link');
      const promoCardLinkTexts = document.querySelectorAll('.promo-card-link-text');
      const promoCardGradientEffects = document.querySelectorAll('.promo-card-gradient-effect');

      for (let promoCount = 0; promoCount < promoCardImages.length; promoCount++) {
        var placeholderElement = document.createElement("div");
  
        if (promoCardImages[promoCount]) {
          var promoCardContent = `
          <div class="grid__item grid__item--promo grid-product small--one-half medium-up--one-quarter">
            <a href="${promoCardLinks[promoCount].innerHTML}" style="background-image: url(${promoCardImages[promoCount].innerHTML})">
              <div class="content">
                <span class="h2">${promoCardTitles[promoCount].innerHTML}</span>
                <button>${promoCardLinkTexts[promoCount].innerHTML}</button>
                <div class="grid-promo-card--inner-text">
                  <p>${promoCardDescriptions[promoCount].innerHTML}</p>
                </div>
              </div>
              ${promoCardGradientEffects[promoCount].innerHTML}
            </a>
          </div>
          `;
  
          promoCardContent = promoCardContent.trim();
  
          placeholderElement.innerHTML = promoCardContent;
          var promoCard = placeholderElement.firstChild;
          var urlParams = new URLSearchParams(window.location.search);
          var currentPage = urlParams.get("page");
          if (currentPage == null) currentPage = 1;
          var currentPage = currentPage - 1;
          var insertPoint =
            currentPage * boostPFSThemeConfig.custom.products_per_page + parseInt(promoCardPositions[promoCount].innerHTML); // based off a 0 index
  
          document.querySelectorAll(".grid-product").forEach(function (el, i) {
            if (i == insertPoint && currentPage == (parseInt(promoCardPages[promoCount].innerHTML) - 1)) {
              el.parentNode.insertBefore(promoCard, el.previousSibling);
            }
          });

        }
      }
    }
  };

  function onColorSwatchHover() {
    document.querySelectorAll(".color-swatch--with-image").forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector(".grid-product__color-image--" + id);
        el.style.backgroundImage = "url(" + image + ")";
        el.classList.add("is-active");
      });
      swatch.addEventListener("mouseleave", function () {
        var id = swatch.dataset.variantId;
        document
          .querySelector(".grid-product__color-image--" + id)
          .classList.remove("is-active");
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function () {
      if (typeof theme !== null && window.theme) {
        if (typeof AOS != "undefined" && typeof AOS.refreshHard == "function") {
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == "function") {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == "function") {
          $(window).off("popstate");
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }
    });
    // Add modal container for quickview
    var isReinitQuickview =
      !isFirstLoad ||
      Utils.isSearchPage() ||
      Globals.queryParams.hasOwnProperty("_");
    if (
      !Utils.isMobile() &&
      boostPFSConfig.custom.quick_shop_enable &&
      isReinitQuickview
    ) {
      jQ(".boost-pfs-quick-shop-modal-container").html("");
      if (data.products.length > 0) {
        data.products.forEach(function (product) {
          var quickUrl =
            Utils.buildProductItemUrl(product) + "?view=boost-pfs-quickview";
          jQ.ajax({
            url: quickUrl,
            success: function (result) {
              numberQuickViewModalLoaded++;
              jQ(".boost-pfs-quick-shop-modal-container").append(result);
              if (numberQuickViewModalLoaded == data.products.length) {
                theme.collapsibles.init();
                numberQuickViewModalLoaded = 0;
                jQ(".quick-product__btn").removeClass("bc-hide");
              }
            },
          });
        });
      }
    }

    // Build total products text
    var totalProductText = "";
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product
      );
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProductText);

    theme.initQuickShop();
  };

  FilterApi.beforeCall = function (eventType, eventInfo) {
    Globals.queryParams.currency =
      boostPFSConfig.general.current_currency.toLowerCase();
    Globals.queryParams.return_all_currency_fields = false;
  };
})();
